import React, { useState } from "react";
import {styled } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Autocomplete from "@material-ui/lab/Autocomplete";
import $ from "jquery";
import { Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Radio, RadioGroup, TextField, Tooltip}from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { updateConfigTemp, updateQuestionSetting } from "../../actions";
import { Grid, tooltipClasses } from "@mui/material";
import { convertData } from "../../function/select_function";
import HelpIcon from '@mui/icons-material/Help';
import { useEffect } from "react";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} placement="left-start" />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#eeeeee",
    color: "#000000",
    maxWidth: 500,
    width: "500px",
    fontSize: theme.typography.pxToRem(14),
    border: "1px solid #dadde9",
  },
}));

function AppearancesFunction() {
  const { question, questionId, languages, choices_list, question_appearance_value, display,config_temp
  } = useSelector((state) => ({
    question: state.question_checked_settings,
    questionId: state.question_checked,
    languages: state.languages,
    choices_list: state.choices_list,
    question_appearance_value: state.questionsList[state.question_checked]
      ? state.questionsList[state.question_checked].question_appearance_value
      : null,
    display: state.questionsList[state.question_checked].display
      ? state.questionsList[state.question_checked].display
      : [],
      config_temp: state.config_temp
  }));
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };
  return (
    <>
        <FormLabel component="legend" style={{color:"#000", fontWeight:"bold", fontSize:"1.2rem"}}>Question Appearance</FormLabel>
        <Box sx={{padding:"15px !important"}}>
          <FormLabel style={{color:"#000", fontWeight: "bold"}}>Appearances:</FormLabel>
            <Autocomplete
              value={question_appearance_value}
              style={{width:'90%'}}
              disablePortal
              id={`${questionId}_combo-box-appearance`}
              name={`${questionId}_appearance`}
              getOptionLabel={(option) =>option.AppearanceString ? option.AppearanceString : ""}
              renderOption={(props) => {
                if (props.AppearanceString) {
                  return (
                    <>
                      <span style={{ width: "100%" }}> {props.AppearanceString}  </span>
                      {
                        props.Description && 
                            <HtmlTooltip
                            title={
                              <React.Fragment>
                                  <img
                                  alt=""
                                  src={props.ImageDescription}
                                  style={{
                                      width: "100%",
                                      borderRadius: "4px",
                                  }}
                                  />
                                  <div
                                  dangerouslySetInnerHTML={{
                                      __html: props.Description,
                                  }}
                                  ></div>
                              </React.Fragment>
                            }
                        >
                            <span><span><HelpIcon color="info"/></span></span>
                        </HtmlTooltip>
                      }
                    </>
                  );
                }
              }}
              onChange={(event, newInputValue) => {
                const val = [newInputValue ? newInputValue.AppearanceDefault : ""]
                const value =[...val,...[display.indexOf("text-nolabel")>-1 ? "text-nolabel" : ""]]
                dispatch( updateQuestionSetting(questionId,"display",value,newInputValue))
                dispatch(updateConfigTemp(questionId,{...config_temp,[questionId]: {}}))
              }}
              options={window.AppearanceString?.filter((appearance) => {
                if (appearance[question?.collector?.XlsType] === "TRUE" &&appearance.Enable === "TRUE") {
                  return appearance;
                }
              })}
              renderInput={(params) => (
                <TextField {...params} />
              )}
            />
        </Box>
        {
        question_appearance_value?.AppearanceKey?.match(/@@(.*?)@@/g) && 
            <Box component="span" sx={{textAlign:"center", width:"100%" }}>
                <FormLabel style={{color:"#000", fontWeight: "bold"}}>Custom appearance: </FormLabel>
                <form id={"formAppearance"} style={{padding: "0 0 0 20px"}}>
                  {question_appearance_value?.AppearanceKey?.match(/@@(.*?)@@/g)?.map((fieldSet) => {
                    let fieldAtribute = fieldSet.replace(/@@/g, "").split("::");
                    return (
                      <div key={fieldSet + "-appearance-form"}>
                        <FieldElement
                          key={fieldSet}
                          choices_list={choices_list}
                          fieldSet={fieldSet}
                          current_language={languages}
                          fieldAtribute={fieldAtribute}
                          question_checked_settings={question}
                          configTemp={config_temp?.[questionId]}
                        />
                      </div>
                    );
                  })}
                </form>
                
                <Box sx={{width:"100%", display:"flex", alignItems:"center", justifyContent:"center"}}>
                  <Button
                    onClick={() => {
                      let arrValue = $(`#formAppearance`).serializeArray();
                      let newValue = {};
                      let newAppearance = question_appearance_value?.AppearanceKey;
                      arrValue?.forEach((key) => {
                        newValue = {
                          ...newValue,
                          [key.name]: key.value,
                        };
                        newAppearance = newAppearance.replace(key.name, key.value);
                      });
                      let temp = {...config_temp,[questionId]: newValue};
                      dispatch(updateQuestionSetting(questionId,"display",[newAppearance],question_appearance_value));
                      dispatch(updateConfigTemp(questionId,temp))
                      handleClick()
                    }}
                    variant="outlined"
                  >
                    Ok
                  </Button>
                </Box>
                <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={open} autoHideDuration={3000} onClose={handleClose}>
                  <Alert  onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                    Appearance updated successfully!
                  </Alert>
                </Snackbar>
            </Box>
        }
        <hr/>
        <FormControl fullWidth style={{padding:"15px"}}>
            <FormLabel style={{color:"#000", fontWeight: "bold"}}>Align</FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={question?.gridformat?.align}
              onChange={(e) => {
                dispatch(updateQuestionSetting(questionId, `align`, e.target.value));
              }}
            >
              <FormControlLabel value="left" control={<Radio />} label="Left" labelPlacement="bottom"/>
              <FormControlLabel value="right" control={<Radio />} label="Right" labelPlacement="bottom"/>
              <FormControlLabel value="center" control={<Radio />} label="Center" labelPlacement="bottom"/>
            </RadioGroup>
        </FormControl>
      </>
  );
}

export default AppearancesFunction;

const FieldElement = ({ ...props }) => {
  let valueField = props.configTemp && props.configTemp?.[props.fieldSet] ? props.configTemp[props.fieldSet] : props.fieldAtribute[2];
  const [value, setValue] = React.useState(valueField);
  const [valueChoice, setValueChoice] = useState({});
  useEffect(()=>{
    let valueField = props.configTemp && props.configTemp?.[props.fieldSet] ? props.configTemp[props.fieldSet] : props.fieldAtribute[2];
    setValue(valueField)
  },[props.configTemp,props.fieldAtribute[2]])
  const handleChange = (e) => {
    if (props.fieldAtribute[1] === "list_items") {
      setValueChoice({ ...valueChoice, [e.target.name]: e.target.checked });
    } else {
      let value = e.target.value;
      if ( props.fieldAtribute[1] === "color" &&valueField?.indexOf("#") === -1) {
        value = value.replace("#", "");
      }
      setValue(value);
    }
  };

  let valueDefault = valueField?.split(",");
  let choicesListNew = [];
  if (props?.choices_list && props?.choices_list?.length > 1) {
    choicesListNew = convertData(props?.choices_list);
  }
  React.useEffect(() => {
    let saveChecked = {};
    choicesListNew[props.question_checked_settings?.choice]?.forEach((item) => {
        saveChecked = {...saveChecked, ...{ [item.name]: valueDefault.indexOf(item.name) > -1 }};
    });
    setValueChoice(saveChecked);
  }, []);
  if (props.fieldAtribute[1] === "list_items") {
    let positions = [];
    Object.entries(valueChoice).forEach((value) => {
      if (value[1]) {
        positions = [...positions, value[0]];
      }
    });
    positions.join(",");
    return (
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <FormLabel style={{textAlign: "left", color:"#000"}} variant="standard">{props.fieldAtribute[0]} </FormLabel>
        </Grid>
        <Grid item xs={6}>
          <FormGroup>
            {choicesListNew[props.question_checked_settings?.choice]?.map(
              (item) => {
                return (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={valueChoice[item.name]}
                        name={item.name}
                        value={item.name}
                        onChange={handleChange}
                      />
                    }
                    label={item[`label::en`]}
                  />
                );
              }
            )}
          </FormGroup>
          <input name={props.fieldSet} type="hidden" value={positions} />
        </Grid>
      </Grid>
    );
  }
  return (
    <div className="row p-3 mb-0 d-flex align-items-center">
      <FormLabel className="col-9" style={{textAlign: "left", color:"#000"}}>{props.fieldAtribute[0]}:</FormLabel>
      <input
        type={props.fieldAtribute[1]}
        onChange={(e) => {
          handleChange(e);
        }}
        value={ props.fieldAtribute[1] === "color" && value?.indexOf("#") === -1 ? "#" + value : value}
        className="form-control col-3"
      />
      <input name={props.fieldSet} type="hidden" value={value} />
    </div>
  );
};
